/**
 * <juro-sweet-spot>: the Untrained / Trained switch on the impact figure
 * ------------------------------------------------------------------
 * Sets data-state on the element; CSS moves the marks. Switches to
 * "after" once, shortly after the figure is first seen, so the point lands
 * without a click, unless the visitor chose first or prefers reduced motion.
 */

(() => {
  if (customElements.get('juro-sweet-spot')) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  class JuroSweetSpot extends HTMLElement {
    connectedCallback() {
      if (this.buttons) return;
      this.buttons = [...this.querySelectorAll('[data-set]')];
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.touched = true;
          this.set(btn.dataset.set);
        });
      });

      if (reduced.matches) return;
      this.io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.io.disconnect();
        setTimeout(() => {
          if (!this.touched) this.set('after');
        }, 2600);
      }, { threshold: 0.5 });
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }

    set(state) {
      this.dataset.state = state;
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.set === state)));
    }
  }

  customElements.define('juro-sweet-spot', JuroSweetSpot);
})();
